import { gql } from '@apollo/client'

export const REAUTHENTICATE = gql`
  mutation Reauthenticate($input: ReauthenticationInput!) {
    reauthenticate(input: $input) {
      session {
        username
        lastAuthenticatedAt
        reauthInfo {
          challengeName
        }
      }
    }
  }
`

export const COMPLETE_AUTH_CHALLENGE = gql`
  mutation CompleteAuthChallenge($input: CompleteAuthChallengeInput!) {
    completeAuthChallenge(input: $input) {
      session {
        username
        lastAuthenticatedAt
        reauthInfo {
          challengeName
        }
      }
    }
  }
`
